import { useSyncExternalStore } from 'react';

import useMe, { hasLikelyValidToken } from '@/renderer/utils/useMe';

function subscribeToStorage(callback: () => void) {
  // Fires when authToken changes in any tab (and in the current tab via the
  // synthetic StorageEvent dispatched by authToken() setter)
  window.addEventListener('storage', callback);
  return () => window.removeEventListener('storage', callback);
}

export function SignInLink({
  signedOut,
  signedIn,
}: {
  signedOut: JSX.Element;
  signedIn: JSX.Element;
}) {
  // useSyncExternalStore tells React that the server snapshot (always false)
  // differs from the client snapshot (localStorage check). React handles this
  // transparently before the first browser paint — no visible flash.
  const isLikelyLoggedIn = useSyncExternalStore(
    subscribeToStorage,
    hasLikelyValidToken,
    () => false, // server snapshot: always logged-out so SSR HTML is consistent
  );

  const me = useMe();

  // Once auth context resolves, use the authoritative value
  if (me !== undefined) {
    return me ? signedIn : signedOut;
  }

  // Auth not yet resolved — use the synchronous localStorage hint
  return isLikelyLoggedIn ? signedIn : signedOut;
}

export default SignInLink;
